export const DEFAULT_DEBOUNCE_TIME = 1000 as const;
